import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";
import { IoInformationCircleOutline } from "react-icons/io5";
import { Select, Tooltip } from "antd";
import { TbReportSearch } from "react-icons/tb";
import { FaChevronDown } from "react-icons/fa6";

const { Option } = Select;

function AiAssistantModeSettings({ aiMode, changeConfig }) {
  const handleChange = (value) => {
    changeConfig("ai_assistant_mode", value);
  };

  return (
    <>
      <div className={styles.stepTitle}>
        <h6>
          <TbReportSearch color="#0c4cfc" size={18} /> What AI assistant mode do
          you wanna use?
        </h6>
      </div>

      <Select
        value={aiMode}
        onChange={handleChange}
        size="large"
        style={{ width: "100%" }}
        dropdownStyle={{ borderRadius: 8 }}
        className={styles.aiDropdown}
        suffixIcon={<FaChevronDown color="black" />}
      >
        <Option value="default">
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            All categories
            <Tooltip
              title="It is recommended since it covers all signals"
              color="#0c4cfc"
            >
              <IoInformationCircleOutline color="#0c4cfc" size={16} />
            </Tooltip>
          </div>
        </Option>

        <Option value="only_ai">Only AI signals</Option>
        <Option value="only_onchain">
          Only on-chain, copy-trading signals
        </Option>
        <Option value="only_social">Only social signals</Option>
        <Option value="only_ta">Only technical indicator signals</Option>
      </Select>

      {/*<div*/}
      {/*  className={styles.aiModeList}*/}
      {/*  style={{ justifyContent: "center" }}*/}
      {/*>*/}
      {/*  <Tooltip*/}
      {/*    title="It is recommended since it covers all signals"*/}
      {/*    color="blue"*/}
      {/*    className={`${styles.sourceItem} ${*/}
      {/*      aiMode === "default" ? styles.active : ""*/}
      {/*    }`}*/}
      {/*    onClick={() => changeConfig("ai_assistant_mode", "default")}*/}
      {/*  >*/}
      {/*    All categories*/}
      {/*    <IoInformationCircleOutline color="#0c4cfc" size={18} />*/}
      {/*  </Tooltip>*/}

      {/*  <span*/}
      {/*    className={`${styles.sourceItem} ${*/}
      {/*      aiMode === "only_ai" ? styles.active : ""*/}
      {/*    }`}*/}
      {/*    onClick={() => changeConfig("ai_assistant_mode", "only_ai")}*/}
      {/*  >*/}
      {/*    Only AI signals*/}
      {/*  </span>*/}

      {/*  <span*/}
      {/*    className={`${styles.sourceItem} ${*/}
      {/*      aiMode === "only_onchain" ? styles.active : ""*/}
      {/*    }`}*/}
      {/*    onClick={() => changeConfig("ai_assistant_mode", "only_onchain")}*/}
      {/*  >*/}
      {/*    Only on-chain, copy-trading signals*/}
      {/*  </span>*/}

      {/*  <span*/}
      {/*    className={`${styles.sourceItem} ${*/}
      {/*      aiMode === "only_social" ? styles.active : ""*/}
      {/*    }`}*/}
      {/*    onClick={() => changeConfig("ai_assistant_mode", "only_social")}*/}
      {/*  >*/}
      {/*    Only social signal*/}
      {/*  </span>*/}

      {/*  <span*/}
      {/*    className={`${styles.sourceItem} ${*/}
      {/*      aiMode === "only_ta" ? styles.active : ""*/}
      {/*    }`}*/}
      {/*    onClick={() => changeConfig("ai_assistant_mode", "only_ta")}*/}
      {/*  >*/}
      {/*    Only technical indicator signals*/}
      {/*  </span>*/}
      {/*</div>*/}
    </>
  );
}

export default AiAssistantModeSettings;
